import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import ReadMore from 'components/program-marketing/read-more'
import Leaderboard from './leaderboard'
import Container from 'components/program-marketing/container'

export const scoringExplanation = 'View all team scores below.'

const LeaderboardSection = ({ program, events, viewScoringRules }) => (
  <Container color="tan">
    <Box mb={2}>
      <Typography variant="h3" color="primary">
        Event Results
      </Typography>
    </Box>
    <Box mb={2}>
      <Typography variant="h2">Leaderboard</Typography>
    </Box>
    <Box mb={4}>
      <ReadMore
        text={scoringExplanation}
        maxLine={1}
        maxLineMobile={2}
        onClick={viewScoringRules}
      />
    </Box>
    <Leaderboard program={program} events={events} />
  </Container>
)

export default LeaderboardSection
